import * as React from 'react';
import { WindowContext } from '../Window.js';

// Hook to use the window object
var useWindow = function useWindow() {
  var contextWindow = React.useContext(WindowContext);
  return contextWindow !== null && contextWindow !== void 0 ? contextWindow : window;
};

export { useWindow };
//# sourceMappingURL=useWindow.js.map
